// extracted by mini-css-extract-plugin
export default {"component":"ywJjkAeH","icon":"bFTUgGOU","text":"NDhf22ge"};